var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:[_vm.getClass]},[(_vm.link && _vm.getContent)?[_c('router-link',{attrs:{"exact":"","to":_vm.toPage(_vm.link)}},[(_vm.getValue)?[_vm._v(" "+_vm._s(_vm.getValue)+" ")]:[_vm._t("default")]],2)]:[(_vm.getValue)?[_vm._v(" "+_vm._s(_vm.getValue)+" ")]:[_vm._t("default")]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }